import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie'

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FormControl, TextField, Grid, Box, MenuItem, Typography, InputLabel, Button, CardMedia } from '@mui/material/';
import Autorize from '../../components/ui/autorize';
import { getSessionValide, getUserRule, setSession, setEmptySession, getCookieEmail, getSessionExpirer } from '../../utils/userRule';

import YouTube from 'react-youtube';

import MyImgLarge from '../../ressource/OFC-large.png';
import croissance from '../../ressource/croissance.png';
import trousse from '../../ressource/trousse.png';
import certificat from '../../ressource/certificat.png';
//import Button from 'react-bootstrap/Button';
import PoPupConsentement from '../../components/lib/dialog_consentement'
//function Home() {
import imageAccueil from '../../ressource/fillette-bd_Opti-jeunesse.jpg';

import authContext from "./authContext";
import UAParser from 'ua-parser-js';

export default function Home() {

  const { token } = useParams();

  const [autorize, setAutorize] = useState(false);
  const [myParam, setmyParam] = useState(useParams());
  const [introuvable, setIntrouvable] = useState(false);
  const [introuvableEmail, setIntrouvableEmail] = useState("");
  const [TokenValide, setTokenValide] = useState(false);

  const { setUserEmail } = useContext(authContext);

  const [openConsentement, setOpenConsentement] = useState(false);

  const navigate = useNavigate();



  const MyAxios = axios.create({
    headers: {
      Authorization: "Bearer " + Cookies.get('token'),
    }
  })

  useEffect(() => {


    const fetchData = async () => {
      try {
        if (await getSessionValide()) {
          let ww = await getCookieEmail();
          // console.log("email = " , ww);
          setAutorize(true);
          setUserEmail(ww);



          //********************** get UI experience ****************/
          const parser = new UAParser();
          const result = parser.getResult();
              
          const userInfo = {
            browser: result.browser.name,
            version: result.browser.version,
            os: result.os.name,
            osVersion: result.os.version,
            device: result.device.type,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            language: navigator.language,
          };
          //console.log( JSON.stringify(userInfo));

          MyAxios.post(process.env.REACT_APP_API + '/utilisateurs/setUserExperience', userInfo) //axios.defaults.withCredentials = true
            .then((res) => {
              console.log("UX validation.");
            })
            .catch((error) => {
              console.log(error);             
            });


          //******************************************************* */


        }
        else
          window.location.href = process.env.REACT_APP_FRONTEND_UI;



      } catch (error) {
        console.error('Une erreur s\'est produite lors de la récupération des données', error);
      }
    };

    fetchData(); // Appel de la fonction asynchrone





    //   await test1(Cookies.get('token'));


  }, []);


  return (
    <div>


        <Grid container justifyContent="center" alignItems="center">
          <Grid  item
                  xs={12}
                  container
                  justifyContent="center"
                  alignItems="center">


             
                <Box sx={{ borderRadius: 3, padding: 1, margin: 1 }} style={{ border: "0px solid grey" }}>
                  <Box
                    component="img"
                    src={imageAccueil}
                    sx={{borderRadius: "30px", width: "500px", height: "auto" }}
                  />
                                    
                </Box>


      
          </Grid>
              


             <Grid
                  item
                  xs={12}
                  container
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="containedThird"
                    href="https://membres.opti-jeunesse.org."
                  >
                    Retour au site Membres
                  </Button>
                </Grid>

              <PoPupConsentement />
      </Grid>

    </div>


  );

}
